import { Component, computed, inject, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MDContentBoxComponent } from '@melodic-ui/components';
import { INotification } from '../../../../api/mylb/interfaces/inotification.interface';
import { UserIconComponent } from '../../../../components';
import { TimeAgoPipe } from '../../../../pipes/time-ago.pipe';
import { NotificationsStateService } from '../../../../state/notifications-state.service';

@Component({
	standalone: true,
	selector: 'lb-notification-base',
	imports: [RouterModule, UserIconComponent, TimeAgoPipe, MDContentBoxComponent],
	template: ` <md-content-box class="activity-card">
		<lb-user-icon [userID]="notification()?.fromUserSummary?.userID" class="icon"> </lb-user-icon>
		<div class="activity-info">
			<div class="activity-header">
				<span class="user-name">{{ senderName() }}</span>
				<span class="time-stamp">{{ notification().createDate | timeAgo }}</span>
			</div>
			<div class="activity-message">
				<ng-content select="[activity-message]"></ng-content>
			</div>
			<div class="activity-action">
				<ng-content select="[activity-action]"></ng-content>
			</div>
		</div>
	</md-content-box>`,
	styleUrl: 'notification-base.component.scss'
})
export class NotificationBaseComponent {
	private _notificationState: NotificationsStateService = inject(NotificationsStateService);
	notification = input.required<INotification>();

	/** Sender display name — preferred name over legal first name when one is set. */
	senderName = computed(() => {
		const sender = this.notification()?.fromUserSummary;
		if (!sender) return '';
		return `${sender.preferredName || sender.firstName} ${sender.lastName}`.trim();
	});

	reloadNotifications(): void {
		this._notificationState.loadNotifications(true);
	}

	dismissNotifications(): void {
		this._notificationState.dismissNotifications(this.notification().notificationID);
	}
}
